import Cookie from 'js-cookie';
import getAdminBarHeight from '../utils/getAdminBarHeight';
export default class AnnouncementBar {
  constructor() {
    this.selector = '.c-announcement-bar';

    this.selectors = {
      close: '.c-announcement-bar__close',
      barTop: '.c-announcement-bar--top',
      root: 'html',
      contentMenu: '.b-content-menu',
    };

    this.className = {
      hasBar: 'document-has-bar',
      barTop: 'c-announcement-bar--top',
      barStuck: 'c-announcement-bar--stuck',
      barHidden: 'c-announcement-bar--hidden',
    };

    this.nodes = {};
  }

  bootstrap() {
    this.getNodes();
    this.handleBars();

    window.addEventListener('load', this.resizeScrollLoad.bind(this));
    window.addEventListener('resize', this.resizeScrollLoad.bind(this));
    window.addEventListener('scroll', this.resizeScrollLoad.bind(this));
  }

  getNodes() {
    this.nodes = {
      bars: [ ...document.querySelectorAll(this.selector) ],
      adminBar: document.getElementById('wpadminbar'),
      root: document.querySelector(this.selectors.root),
      contentMenu: document.querySelectorAll(this.selectors.contentMenu),
    };
  }

  resizeScrollLoad() {
    this.handleRootClasses();
    this.topBarPosition({ bar: document.querySelector(this.selectors.barTop) });
  }

  topBarPosition({ bar }) {
    if (!bar) {
      return;
    }

    const offset = getAdminBarHeight({ node: this.nodes.adminBar });

    if (bar.classList.contains(this.className.barTop)) {
      // eslint-disable-next-line no-param-reassign
      bar.style.top = `${offset}px`;
    }
  }

  handleBars() {
    const { bars, contentMenu } = this.nodes;

    if (bars.length === 0) {
      return;
    }

    bars.forEach(bar => {
      const close = bar.querySelector(this.selectors.close);

      if (close) {
        close.addEventListener('click', event => {
          event.preventDefault();

          bar.classList.add(this.className.barHidden);

          Cookie.set(bar.dataset.barId, true, { expires: 7 });

          this.handleRootClasses();

          setTimeout(() => {
            $(window).trigger('announcement-bar-hiding');
            document.documentElement.style.setProperty('--announcement-bar-height', '0px');
          }, 500);
        });
      }

      if (contentMenu.length > 0) {
        bar.classList.add(this.className.barStuck);
      }
    });
  }

  handleRootClasses() {
    const barTop = document.querySelector(this.selectors.barTop);
    const { root } = this.nodes;

    if (!barTop) {
      return;
    }

    if (barTop.classList.contains(this.className.barHidden)) {
      root.classList.remove(this.className.hasBar);
    } else {
      root.classList.add(this.className.hasBar);
    }
  }
}
